import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/CTALink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
